const ns = "ORGANIZATION";
export const REQUEST = `${ns}_REQUEST`;
export const RECEIVE = `${ns}_RECEIVE`;

export const UNAUTHORIZED_OPERATION_ERROR = 403;
